import React from 'react';
import {connect} from 'react-redux';

import {isEmpty} from 'lodash';

import EquipmentTable from './EquipmentTable';

import ActionBar from '../../components/ActionBar';
import { TabContent } from '../../components/TabPanel';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableAndSearch.module.css';

const EquipmentTableAndSearch = ({
    equipment,
    fetchEquipmentBySystemId,
    handleSort,
    isFullArchitectAllowed,
    onToggleDeleteEquipmentEntityModal,
    order,
    orderBy,
    selectedNode,
    ...props
}) => {

    const handleSearch = searchFilter => {
        if (isEmpty(searchFilter)) {
            fetchEquipmentBySystemId(selectedNode);
        } else {
            fetchEquipmentBySystemId(selectedNode, {searchFilter});
        }
    };

    return (
        <TabContent
            classes={{
                root: classes.tabContent
            }}
        >
            <ActionBar
                onSearch={handleSearch}
            />
            <div className={classes.scrollContainer}>
                <EquipmentTable
                    equipment={equipment}
                    order={order}
                    orderBy={orderBy}
                    onSort={property => handleSort(props, property)}
                    onToggleDeleteEquipmentEntityModal={onToggleDeleteEquipmentEntityModal}
                    isFullArchitectAllowed={isFullArchitectAllowed}
                    showContextMenu={true}
                    filterBy="system"
                />
            </div>
        </TabContent>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(EquipmentTableAndSearch);
